import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CollapsableNodeStateStoreService {
  private data = new Map<string, Map<string, boolean>>();

  public updateSingleState(elementId: string, key: string, value: boolean): void {
    let storedState = this.data.get(elementId);
    if (!storedState) {
      storedState = new Map<string, boolean>();
    }

    storedState.set(key, value);

    this.data.set(elementId, storedState);
  }

  public getSingleState(elementId: string, key: string, defaultValue: boolean): boolean {
    const storedState = this.data.get(elementId);
    if (!storedState) {
      return defaultValue;
    }

    return storedState.get(key) ?? defaultValue;
  }

  public getStoredStates(currentNodes: Map<string, boolean>, elementId: string): Map<string, boolean> {
    const storedState = this.data.get(elementId);
    if (!storedState) {
      return currentNodes;
    }

    for (const key of currentNodes.keys()) {
      const storedValue = storedState.get(key);
      currentNodes.set(key, storedValue ?? false);
    }

    return currentNodes;
  }
}
